var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1796 4.35673C17.1796 3.04279 18.2596 1.97583 19.5896 1.97583C20.9196 1.97583 21.9996 3.04279 21.9996 4.35673C21.9996 5.67068 20.9196 6.73764 19.5896 6.73764C18.2596 6.73764 17.1796 5.67068 17.1796 4.35673ZM13.3295 14.5811L16.2195 10.8971L16.1795 10.9169C16.3395 10.6995 16.3695 10.4229 16.2595 10.1759C16.1505 9.92893 15.9095 9.76099 15.6505 9.74123C15.3795 9.71159 15.1105 9.83014 14.9495 10.0475L12.5305 13.1397L9.75951 10.986C9.58951 10.8576 9.38951 10.8072 9.18951 10.8279C8.99051 10.8576 8.81051 10.9653 8.68951 11.1233L5.73051 14.9278L5.66951 15.0168C5.49951 15.3319 5.57951 15.737 5.87951 15.9553C6.01951 16.0442 6.16951 16.1035 6.33951 16.1035C6.57051 16.1134 6.78951 15.9938 6.92951 15.8071L9.43951 12.6151L12.2895 14.7303L12.3795 14.7885C12.6995 14.9565 13.0995 14.8784 13.3295 14.5811ZM15.4495 3.73464C15.4095 3.98162 15.3895 4.2286 15.3895 4.47558C15.3895 6.69841 17.2095 8.49545 19.4495 8.49545C19.6995 8.49545 19.9395 8.4668 20.1895 8.42729V16.3989C20.1895 19.7489 18.1895 21.7347 14.7895 21.7347H7.40051C3.99951 21.7347 1.99951 19.7489 1.99951 16.3989V9.0892C1.99951 5.73025 3.99951 3.73464 7.40051 3.73464H15.4495Z",
    fill: "#1A374E",
    fillOpacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications_icon.29c49ca1aed5577b2022a71dd1437c67.svg";
export { ForwardRef as ReactComponent };